import { css, html } from "lit";
import { component } from "../view.ts";
import * as Styles from "../../styles.ts";

const styles = css`
  :host {
    --logo-size: var(--space-3_5);
    display: block;
  }

  .lockup {
    color: var(--foreground);
    display: flex;
    flex-direction: row;
    gap: var(--space-2);
    align-items: center;
    white-space: nowrap;
  }

  .lockup-text {
    font-size: var(--font-size-sm);
    line-height: var(--line-height-snug);
    font-weight: var(--font-weight-bold);
    letter-spacing: var(--letter-spacing-tight);
  }

  .logo {
    background-color: var(--brand);
    width: var(--logo-size);
    height: var(--logo-size);
    display: block;
    border-radius: calc(var(--logo-size) / 2);
    box-shadow: 0 0 3rem 0 color-mix(in oklch, var(--brand) 10%, transparent);
    display: none;
  }
`;

const LogoView = () => {
  return html`
    <div class="lockup">
      <div class="logo"></div>
      <div class="lockup-text">Deep Future</div>
    </div>
  `;
};

LogoView.styles = [Styles.base, styles];

customElements.define("app-logo", component(LogoView));
